import { _js } from '@ifixit/utils/localize';
import { store } from 'Shared/react-initialize';
import * as HeaderActions from 'Shared/Header/actions';
import { jsonBody, webApiClient } from 'Shared/web_api_client';

// Every workbench endpoint answers with the whole workbench, which the header
// shows. done() rethrows a failure, as it did before this used fetch.
function postWorkbench(endpoint, statName, data) {
   const request = sendToWorkbench(endpoint, statName, data);
   request.done(response => {
      store.dispatch(HeaderActions.updateWorkbench(response.topics));
   });
   return request;
}

async function sendToWorkbench(endpoint, statName, data) {
   const client = await webApiClient();
   return client.post(endpoint, statName, jsonBody(data));
}

const WorkbenchManager = {
   addItem: function (topicVariantid, wikiid, useIndicator, topicTitle) {
      topicTitle = topicTitle ? topicTitle : null;
      let request = postWorkbench('user/workbench/add?langid=' + App.lang, 'workbench-add', {
         wikiid: wikiid,
         topicVariantid: topicVariantid,
         topicTitle: topicTitle,
         productcode: App.productcode,
         source: 'wiki',
      });

      if (useIndicator) {
         LoadingIndicator.withPromise(request, {
            pendingMessage: _js('Adding'),
            successMessage: _js('Added'),
         });
      }
   },

   removeItem: function (topicVariantid, wikiid, useIndicator) {
      let request = postWorkbench('user/workbench/remove?langid=' + App.lang, 'workbench-remove', {
         wikiid: wikiid,
         topicVariantid: topicVariantid,
      });

      if (useIndicator) {
         LoadingIndicator.withPromise(request, {
            pendingMessage: _js('Removing'),
            successMessage: _js('Removed'),
         });
      }
   },

   setActiveItem: function (dropdownId) {
      dropdownId = dropdownId.split('-');
      let wikiid = parseInt(dropdownId[0], 10);
      let topicVariantid = dropdownId[1];

      postWorkbench('user/workbench/set_active', 'workbench-set-active', {
         wikiid: wikiid,
         topicVariantid: topicVariantid,
      });
   },
};

export default WorkbenchManager;
